import { useState } from "react";
import { toast } from "sonner";

export const fmtCode = (v) => v.replace(/[^\d]/g, "").slice(0, 12).replace(/(\d{4})(?=\d)/g, "$1-");

// Copia o código (só para a área de transferência) e abre a página oficial numa nova janela.
export function verCertidao(url, code) {
  if (code) {
    navigator.clipboard.writeText(code)
      .then(() => toast.success("✓ Código copiado, cole no campo do site", { duration: 3000 }))
      .catch(() => {});
  }
  window.open(url, "_blank", "noopener,noreferrer");
}

export function CodeInput({ onSave, big, testid, label = "Guardar" }) {
  const [v, setV] = useState("");
  const ok = v.replace(/\D/g, "").length === 12;
  return (
    <div className={big ? "space-y-3" : "flex items-center gap-2"}>
      <input value={v} onChange={(e) => setV(fmtCode(e.target.value))} inputMode="numeric" placeholder="1234-5678-9012" data-testid={`${testid}-input`}
        className={big ? "w-full h-14 rounded-xl border-2 border-slate-300 focus:border-sky-600 outline-none px-4 text-2xl tracking-widest font-mono"
          : "h-9 w-44 rounded-lg border border-slate-200 px-2.5 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-sky-200"} />
      <button type="button" disabled={!ok} onClick={() => onSave(v)} data-testid={`${testid}-save`}
        className={big ? "w-full h-12 rounded-xl text-white font-semibold disabled:opacity-50 bg-[var(--btn)]"
          : "h-9 px-3 rounded-lg bg-ec-green text-white text-sm font-semibold disabled:opacity-50"}>{label}</button>
    </div>
  );
}
